/**
 * Homepage project showcase data — proof summaries for SEO and AI search.
 */

export const PROJECT_CATEGORIES = [
  { id: 'all', label: 'All' },
  { id: 'websites', label: 'Websites' },
  { id: 'ecommerce', label: 'Ecommerce' },
  { id: 'ai', label: 'AI' },
  { id: 'platforms', label: 'Platforms' },
  { id: 'cms', label: 'CMS' },
];

export const PROOF_CHIPS = ['Web platforms', 'Ecommerce', 'AI interfaces', 'Custom systems', 'CMS builds'];

export const HOME_PROJECTS = [
  {
    id: 'wecharge',
    title: 'Wecharge Fulling India',
    href: 'https://wecharge.co.in/',
    image: 'img/wecharge-p-1.png',
    alt: 'Wecharge Fulling India ecommerce website screenshot',
    label: 'View Wecharge Fulling India project',
    category: 'Ecommerce / energy',
    categoryId: 'ecommerce',
    summary: 'Product-led ecommerce presence with catalog UX and conversion-focused storefront flows.',
    services: ['Ecommerce', 'PHP', 'Integrations'],
    featured: true,
    layout: 'feature',
  },
  {
    id: 'ai-chatbot',
    title: 'AI Chatbot',
    href: 'https://web.kailashchandra.com/tosall_client/',
    image: 'img/tosall-p-1.png',
    alt: 'AI chatbot client interface screenshot',
    label: 'View AI chatbot project',
    category: 'AI interface',
    categoryId: 'ai',
    summary: 'Conversational client interface with guided flows and support-ready handoff patterns.',
    services: ['AI', 'React', 'APIs'],
    featured: false,
    layout: 'rail',
  },
  {
    id: 'trueopinion',
    title: 'TrueOpinion',
    href: 'https://surveys.authenticopinion.com/clientpanel',
    image: 'img/trueopinion-p-1.png',
    alt: 'TrueOpinion survey platform dashboard screenshot',
    label: 'View True Opinion project',
    category: 'Survey platform',
    categoryId: 'platforms',
    summary: 'Client panel for survey operations with structured data views and role-friendly workflows.',
    services: ['Platform', 'PHP', 'Dashboard'],
    featured: false,
    layout: 'rail',
  },
  {
    id: 'tipster',
    title: 'Tipster Challenge',
    href: 'https://tipsterchallenge.com/',
    image: 'img/tipster-challenge-1.png',
    alt: 'Tipster Challenge community platform screenshot',
    label: 'View Tipster Challenge project',
    category: 'Community platform',
    categoryId: 'platforms',
    summary: 'Engagement-focused web platform for challenges, rankings, and member participation.',
    services: ['PHP', 'UX', 'Community'],
    featured: false,
    layout: 'bento-md',
  },
  {
    id: 'sae',
    title: 'SAE',
    href: 'https://www.sae.edu/',
    image: 'img/portfolio-sae-edu-au.png',
    alt: 'SAE education website screenshot for a multi-region digital platform',
    label: 'View SAE project',
    category: 'Education platform',
    categoryId: 'platforms',
    summary: 'Education website experience supporting regional content, programme discovery, and enquiry paths.',
    services: ['Education', 'CMS', 'Frontend'],
    featured: false,
    layout: 'bento-md',
  },
  {
    id: 'acap',
    title: 'ACAP',
    href: 'https://www.acap.edu.au/',
    image: 'img/portfolio-acap-edu-au.png',
    alt: 'ACAP education website screenshot with course discovery interface',
    label: 'View ACAP project',
    category: 'Education website',
    categoryId: 'websites',
    summary: 'Course-focused website work for student research journeys, content clarity, and enquiry conversion.',
    services: ['Education UX', 'CMS', 'SEO'],
    featured: false,
    layout: 'bento-sm',
  },
  {
    id: 'evanik',
    title: 'Evanik',
    href: 'https://www.evanik.ai/',
    image: 'img/portfolio-evanik-ai.png',
    alt: 'Evanik AI ecommerce management platform homepage screenshot',
    label: 'View Evanik project',
    category: 'Ecommerce operations',
    categoryId: 'ecommerce',
    summary: 'Operational ecommerce platform presence shaped around marketplace workflows and seller productivity.',
    services: ['Ecommerce', 'Marketplace', 'UX'],
    featured: false,
    layout: 'bento-sm',
  },
  {
    id: 'elitesewa',
    title: 'EliteSewa',
    href: 'https://www.elitesewa.com/',
    image: 'img/portfolio-elitesewa-service-view.png',
    alt: 'EliteSewa mobile service view screenshot for daily car wash booking',
    label: 'View EliteSewa project',
    category: 'Service platform',
    categoryId: 'platforms',
    summary: 'Service-led platform experience designed around discovery, trust signals, and request workflows.',
    services: ['Platform', 'Service UX', 'Frontend'],
    featured: false,
    layout: 'bento-sm',
  },
  {
    id: 'indiasellers',
    title: 'India Sellers',
    href: 'https://www.indiasellers.com/',
    image: 'img/portfolio-indiasellers-com.png',
    alt: 'India Sellers B2B marketplace website screenshot',
    label: 'View India Sellers project',
    category: 'B2B marketplace',
    categoryId: 'platforms',
    summary: 'B2B marketplace experience for seller discovery, product categories, services, and lead generation.',
    services: ['Marketplace', 'Catalogs', 'SEO'],
    featured: false,
    layout: 'bento-md',
  },
  {
    id: 'cashew',
    title: 'Cashew Protect',
    href: 'https://web.kailashchandra.com/cashewprotect/',
    image: 'img/cashew-p-1.png',
    alt: 'Cashew Protect brand website screenshot',
    label: 'View Cashew Protect project',
    category: 'Brand website',
    categoryId: 'websites',
    summary: 'Brand storytelling site with clear product positioning and trust-building content structure.',
    services: ['WordPress', 'CMS', 'SEO'],
    featured: false,
    layout: 'rail',
  },
];

export const getFeaturedProject = () => HOME_PROJECTS.find((p) => p.featured) || HOME_PROJECTS[0];

export const getRailProjects = () =>
  HOME_PROJECTS.filter((p) => p.layout === 'rail');

export const getBentoProjects = () =>
  HOME_PROJECTS.filter((p) => p.layout && p.layout.startsWith('bento'));

export const getSliderProjects = () =>
  HOME_PROJECTS.filter((p) => !p.featured);
